






































































import { PropType } from 'vue';

import { IQuoteProductDocument } from '@/models';
import { FormType } from './DocumentDetailFormDialog.vue';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

export default mixins(auth).extend({
  name: 'DocumentDetailOptionsButton',

  props: {
    document: {
      type: Object as PropType<IQuoteProductDocument>
    }
  },

  data() {
    return {
      FormType
    };
  }
});
